export default __webpack_public_path__ + "static/hcf-3180dae63103841ab4a1d4d34c2bacb3.jpg";